import styled, { css } from 'styled-components';
import { IconName } from './types';
import { Icon } from './Icon';
import { colors } from '@ardoq/design-tokens';

type AnimatedChevronTransientProps = {
  $isUp?: boolean;
};
export const AnimatedChevron = styled(Icon).attrs({
  iconName: IconName.CHEVRON_DOWN,
})<AnimatedChevronTransientProps>`
  transition: transform 0.2s ease-in-out;
  color: ${colors.grey500};
  ${({ $isUp }) =>
    $isUp &&
    css`
      && {
        transform: rotate(180deg);
        color: ${colors.grey700};
      }
    `}
`;
